import businessApi from '@/api/businessApi';
import { useGlobalConfigStoreHook } from '@/stores/globalConfig';
import type { AxiosRequestConfig } from 'axios';
import _ from 'lodash';

export async function fetchGlobalConfig(options?: AxiosRequestConfig) {
  const store = useGlobalConfigStoreHook();
  const res = await businessApi.getGlobalConfig(options).catch((error) => {
    console.error('获取全局配置失败:', error);
    return null;
  });
  store.setConfig(res?.data || {});
  return store.config;
}

// export async function fetchGlobalConfigIfNeeded() {
//   const store = useGlobalConfigStoreHook();
//   if (store.loaded) {
//     return store.config;
//   }
//   return fetchGlobalConfig({ notShowError: true });
// }

// export function getGlobalConfigCache() {
//   return useGlobalConfigStoreHook().config;
// }

// export function getGlobalConfigValue<T = any>(key: string, fallback?: T): T | undefined {
//   const config = getGlobalConfigCache();
//   const value = _.get(config, key);
//   return (value ?? fallback) as T | undefined;
// }
